import React from 'react';
import Icon from './Icon';

// Must match CANONICAL_ARCHETYPES in archetype_engine.py
const ARCHETYPE_META = {
  "The Dynasty Architect":   { color: '#ffd32a', icon: '🏛️' },
  "The Win-Now Mercenary":   { color: '#ff6b35', icon: '⚔️' },
  "The Deadline Raider":     { color: '#ff4757', icon: '⏰' },
  "The Trade Addict":        { color: '#a855f7', icon: '🔄' },
  "The Reluctant Rebuilder": { color: '#888888', icon: '🔧' },
  "The Sleeper Cell":        { color: '#00d4ff', icon: '🥷' },
  "The Draft Evangelist":    { color: '#00e676', icon: '📋' },
  "The Chaos Agent":         { color: '#e040fb', icon: '🌪️' },
  "The Ironclad":            { color: '#4dc8e8', icon: '🛡️' },
  "The Legacy Builder":      { color: '#c8a200', icon: '👑' },
};

/**
 * ArchetypeBadge — compact archetype display.
 *
 * Props:
 *   archetype  — archetype name string
 *   size       — 'sm' (default) | 'lg'
 *   showName   — show text label (default true)
 *   showIcon   — show emoji icon (default true)
 */
export default function ArchetypeBadge({
  archetype,
  size = 'sm',
  showName = true,
  showIcon = true,
}) {
  const meta = ARCHETYPE_META[archetype] || { color: '#888888', icon: '🎯' };
  const isLg = size === 'lg';

  return (
    <span
      style={{
        display:     'inline-flex',
        alignItems:  'center',
        gap:         isLg ? 6 : 4,
        padding:     isLg ? '5px 12px' : '3px 8px',
        borderRadius: 8,
        background:  meta.color + '15',
        border:      `1px solid ${meta.color}33`,
        color:       meta.color,
        fontSize:    isLg ? '0.78rem' : '0.65rem',
        fontFamily:  'var(--font-mono)',
        fontWeight:  600,
        lineHeight:  1,
        whiteSpace:  'nowrap',
        cursor:      'default',
      }}
      title={archetype}
    >
      {showIcon && (
        <Icon emoji={meta.icon} size={isLg ? 16 : 13} />
      )}
      {showName && archetype}
    </span>
  );
}

/** Icon-only variant — useful in tight spaces like standings rows. */
export function ArchetypeIcon({ archetype, size = 18 }) {
  const meta = ARCHETYPE_META[archetype] || { color: '#888888', icon: '🎯' };
  return (
    <span
      title={archetype}
      style={{
        display:        'inline-flex',
        alignItems:     'center',
        justifyContent: 'center',
        width:          size,
        height:         size,
        borderRadius:   4,
        background:     meta.color + '18',
        fontSize:       size * 0.6,
        lineHeight:     1,
        cursor:         'default',
      }}
    >
      <Icon emoji={meta.icon} size={Math.round(size * 0.6)} />
    </span>
  );
}
